import React from 'react';

// Components
import TargetList from './components/TargetList';

// Types
import { RiskProfileRule } from '@/types/risk-profiles';

// Utils
import { transformRulesToTargets } from './utils/target-transformers';

interface TargetsFromRulesProps {
  rules?: RiskProfileRule[];
}

const TargetsFromRules: React.FC<TargetsFromRulesProps> = ({ rules }) => {
  if (!rules?.length) {
    return null;
  }

  const targets = transformRulesToTargets(rules);

  return <TargetList targets={targets} />;
};

export default TargetsFromRules;
